<template>
  <div v-loading="loading">
    <el-form ref="form" :inline="true" class="form" :model="form">
      <div class="rj-row">
        <div class="rj-col-2">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              合同编号：
            </div>
            <div class="rj-baseinfo__item">
              {{ form.contractNum }}
            </div>
          </div>
        </div>
        <div class="rj-col-2">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              项目名称：
            </div>
            <div class="rj-baseinfo__item">
              {{ form.projectName }}
            </div>
          </div>
        </div>
      </div>
      <div class="rj-row">
        <div class="rj-col-2">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              供货单位：
            </div>
            <div class="rj-baseinfo__item">
              {{ form.supplyUnit }}
            </div>
          </div>
        </div>
        <div class="rj-col-2">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              订货单位：
            </div>
            <div class="rj-baseinfo__item">
              {{ form.orderUnit }}
            </div>
          </div>
        </div>
      </div>
      <div class="rj-row">
        <div class="rj-col-1">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              分配明细
            </div>
          </div>
        </div>
      </div>
      <el-table :data="dataList" border style="width: 100%" :summary-method="getSummaries" show-summary>
        <el-table-column type="index" width="70" label="序号" align="left" fixed="left" />
        <el-table-column prop="telegraphicTransferNum" label="电汇底单编号" align="left" />
        <el-table-column prop="orderSales" label="订单金额" align="right" header-align="left" width="160" />
        <el-table-column prop="assignAmount" label="已分配金额" align="right" header-align="left" width="160" />
        <el-table-column prop="usedScale" label="已分配金额比例" align="right" header-align="left" width="160" />
        <el-table-column prop="createBy" label="分配人" align="left" />
        <el-table-column prop="createTime" label="分配日期" align="left" />
        <el-table-column prop="state" label="状态" align="left" />
      </el-table>
      <div class="rj-row">
        <div class="rj-col-1">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              申请撤销理由： <span>{{ reason }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="rj-row">
        <div class="rj-col-1">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              审批意见
            </div>
          </div>
        </div>
      </div>
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="approver" label="审批人" align="left" />
        <el-table-column prop="approvalOpinion" label="审批内容" align="left" />
        <el-table-column prop="approvalTime" label="审批时间" align="left" />
        <el-table-column prop="approvalResult" label="是否同意" align="left" />
      </el-table>
    </el-form>
  </div>
</template>

<script>
import { distributionViewTHH } from '@/API';
export default {
  name: 'Examine',
  data () {
    return {
      form: {},
      dataList: [],
      tableData: [],
      reason: '',
      loading: false
    };
  },
  props: {
    id: {
      type: Number,
      default: 0
    }
  },
  methods: {
    initData () {
      this.loading = true;
      distributionViewTHH(this.id).then((res) => {
        this.loading = false;
        let json = res.data;
        if (json.status === '200') {
          this.form = json.data;
          this.reason = json.data.reason;
          this.dataList = json.data.assignDetailVOList;
          this.tableData = json.data.telFundManagementApprovalRecords;
        }
      }).catch(() => {
        this.loading = false;
      });
    },
    // 合计
    getSummaries (param) {
      const { columns } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (column.label === '订单金额') {
          sums[index] = this.orderSales();
        }
        if (column.label === '已分配金额') {
          sums[index] = this.assignAmount();
        }
      });
      return sums;
    },
    orderSales () {
      let cont = 0;
      this.dataList.forEach((item) => {
        cont += Number(item.orderSales);
      });
      return cont.toFixed(2);
    },
    assignAmount () {
      let cont = 0;
      this.dataList.forEach((item) => {
        cont += Number(item.assignAmount);
      });
      return cont.toFixed(2);
    }
  },
  mounted () {
    this.initData();
  }
};
</script>
